module.exports = __webpack_public_path__ + "static/RoslindaleText-Regular-5c78cd04830e09ffc4c33b430e040c3e.woff";